var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5.44444V2.11111V1H9.88891H6.55557V2.11111H8.77776V3.22195H9.88887V2.11111H9.88891V5.44444H11ZM5.44444 2.11084H2.11111H1V3.22195V9.88916V10.9997V11.0003H8.77776H9.88887H9.88889V9.88916H9.88887V6.55583H8.77776V9.88916H2.11111V3.22195H5.44444V2.11084ZM4.33333 6.55583H5.44444V7.66694H4.33333V6.55583ZM6.55554 5.44417H5.44443V6.55528H6.55554V5.44417ZM6.55557 4.33333H7.66667V3.22249H8.77778V4.3336H7.66668V5.44444H6.55557V4.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkS);
export default __webpack_public_path__ + "static/media/external-link-s.79ad8ee401758ead83422efcfb0c0314.svg";
export { ForwardRef as ReactComponent };